module.exports = __webpack_public_path__ + "static/media/hair-stylists-banner.e17a0edc.jpg";